import type React from 'react'
import { cn } from '@/lib/utils'

/**
 * Shimmer placeholder bar.
 *
 * Uses `bg-muted` + a foreground-tinted gradient so the shimmer stays visible
 * in light **and** dark, including nested `.light` / `.dark` chart islands
 * (where a root-level `dark:` utility would be wrong).
 */
export function Skeleton({
  className,
  ...props
}: React.ComponentProps<'div'>): React.ReactElement {
  return (
    <div
      className={cn(
        'animate-skeleton rounded-sm bg-muted',
        // Island-safe: tracks local --foreground, not html.dark.
        '[--skeleton-highlight:color-mix(in_srgb,var(--color-foreground)_14%,transparent)]',
        '[background-image:linear-gradient(105deg,transparent_38%,var(--skeleton-highlight)_50%,transparent_62%)]',
        '[background-size:200%_100%]',
        '[background-repeat:no-repeat]',
        className,
      )}
      data-slot="skeleton"
      {...props}
    />
  )
}
